/* global Swiper */
const loadEventVerticalScrollBar = {
	el: {
		verticalScrollBarContainer: document.querySelectorAll('.js-vertical-scrollbar')
	},

	fxInitVerticalScrollbar(el) {

		// Swiper options
		const verticalSwiperScrollOptions = {
			direction: 'vertical',
			slidesPerView: 'auto',
			freeMode: true,
			mousewheel: true,
			scrollbar: {
				snapOnRelease: false,
				draggable: true,
				el: el.querySelector('.swiper-scrollbar')
			}
			
		}

		// Initialize Swiper
		new Swiper(el, verticalSwiperScrollOptions)
	},

	init() {
		// Loop through each vertical scrollbar container
		window.addEventListener('load', () => this.el.verticalScrollBarContainer.forEach(el => this.fxInitVerticalScrollbar(el)))

	}
}
loadEventVerticalScrollBar.init()